"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbTestingService = void 0;
class AbTestingService {
    static QID = 'AB_Testing';
    static getTestValueInner(name, abtests_q) {
        if (!abtests_q || !abtests_q.value || typeof abtests_q.value !== 'string') {
            return '';
        }
        const abtests_v = JSON.parse(abtests_q.value);
        if (!abtests_v || (typeof abtests_v !== 'object') || !Object.keys(abtests_v).length) {
            return '';
        }
        const test = abtests_v[name];
        if (!test) {
            return '';
        }
        return test;
    }
    static generateTestingData({ schema, override, isMobile = null, externalAgent }) {
        const functionName = 'generateTestingData';
        const result = {};
        const abtests_q = schema.questions.find(q => q.questionId === this.QID);
        const abtests = abtests_q.metadata.tests;
        // log 
        console.log({ functionName, schema, override, isMobile, externalAgent, abtests });
        // for internal and external agents
        if (override) {
            result['driver'] = 'after_pricing';
            result['packages'] = 'with_installment';
            result['ocr'] = 'no_form';
        }
        // regular user
        else {
            for (const [name, options] of Object.entries(abtests)) {
                const random = Math.random();
                const index = Math.floor(random * options.length);
                console.log({ functionName, message: `AB Testing: ${name}=${options[index]}`, index, options, random });
                result[name] = options[index];
                console.log({ functionName, name, options, index, result });
            }
            // setting ocr option to with_form
            result['ocr'] = 'with_form';
            //log
            console.log({ functionName, result });
            // this way we make sure apps with no ocr mobile support on mobile or with externalAgent will not get the ocr test
            // we don't have mobile ocr support yet
            if (isMobile || externalAgent) {
                result['ocr'] = 'no_form';
            }
            result['driver'] = 'before_pricing';
        }
        // setting option to always be paid_in_full, and for driver to be before_pricing. To return to original override func remove next lines
        result['packages'] = 'paid_in_full';
        // over writing since currently after_pricing is DEPRECIATED 
        result['driver'] = 'before_pricing';
        // log  
        console.log({ functionName, result });
        return result;
    }
    static getTestValue(questionnaire, name) {
        if (!questionnaire?.questions) {
            return '';
        }
        const abtests_q = questionnaire.questions.find(q => q.questionId === this.QID);
        return AbTestingService.getTestValueInner(name, abtests_q);
    }
}
exports.AbTestingService = AbTestingService;
